module.exports = __webpack_public_path__ + "img/logo-comuna-energetica.8e1b6252.png";